import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { Row, Col, Button, Alert } from 'reactstrap'
import ReactSelect from 'react-select'
import useFetchingReportCompanies from './useFetchingReportCompanies'
import LoadingSpinner from '../Shared/LoadingSpinner'
import PageContainer from '../Shared/LayoutComponents/PageContainer'
import PageHeading from '../Shared/LayoutComponents/PageHeading'
import ReportDetails from './ReportDetails'
import { reportingCompanySelected, runSync } from '../actions/reportsActions'
import { authProvider } from '../../services/authProvider'
import store from '../../store/configureStore'
import { AzureAD } from 'react-aad-msal'
import { useState } from 'react'

const Reports = (props) => {
    useFetchingReportCompanies()
    const dispatch = useDispatch()
    let [hasRunSync, setHasRunSync] = useState(false)

    const runReport = () => {
        setHasRunSync(true);
        dispatch(runSync())
    }
    if (props.loading) {
        return <LoadingSpinner />
    } else {
        return (
            <AzureAD provider={authProvider} reduxStore={store}>
                {({ login, logout, authenticationState, accountInfo }) => {
                    let isAdminOrSales = false
                    if (accountInfo && accountInfo.account && accountInfo.account.idToken && accountInfo.account.idToken.roles) {
                        if (accountInfo.account.idToken.roles.includes('Admin')) {
                            isAdminOrSales = true
                        } else if (accountInfo.account.idToken.roles.includes('Sales')) {
                            isAdminOrSales = true
                        }
                    }

                    return (
                        <PageContainer>
                            <Row>
                                <PageHeading>Veeam 365 Backup Reporting</PageHeading>
                            </Row>
                            <div>
                                <div style={{ width: '50%', display: 'inline-block' }}>
                                    <div>Select a client</div>
                                    <ReactSelect
                                        value={props.selectedCompany}
                                        onChange={(property, value) => dispatch(reportingCompanySelected(property))}
                                        isClearable
                                        isSearchable
                                        options={props.reportCompanyList}
                                    />
                                </div>
                                <div style={{ width: '50%', display: 'inline-block' }}>
                                    {isAdminOrSales && <Button color="primary" onClick={() => runReport()} style={{ float: 'right' }}>Run Veeam Sync</Button>}
                                    {hasRunSync && <Alert color="success" style={{ margin: '50px 10px' }}>Veeam Sync triggered, You'll receive an email once it has completed.</Alert> }
                                </div>
                            </div>
                            <div>
                                {props.reportDetails ? (
                                    <div style={{ marginTop: '30px' }}>
                                        <ReportDetails reportDetails={props.reportDetails} />
                                    </div>
                                ) : (
                                    props.selectedCompany && (
                                        <div style={{ marginTop: '30px' }}>
                                            <PageHeading>Details for {props.selectedCompany.label}</PageHeading>
                                            <div>Report not found</div>
                                        </div>
                                    )
                                )}
                            </div>

                        </PageContainer>
                    )
                }}
            </AzureAD>
        )
    }
}

const mapStateToProps = (state) => ({
    loading: state.reports.loading,
    reportCompanyList: state.reports.reportCompanyList,
    selectedCompany: state.reports.selectedCompany,
    reportDetails: state.reports.reportDetails,
})

const mapDispatchToProps = {
    reportingCompanySelected,
    runSync
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports)